import { render, staticRenderFns } from "./activity-read-only-questions.vue?vue&type=template&id=29c325e1&scoped=true&"
import script from "./activity-read-only-questions.vue?vue&type=script&lang=js&"
export * from "./activity-read-only-questions.vue?vue&type=script&lang=js&"
import style0 from "./activity-read-only-questions.vue?vue&type=style&index=0&id=29c325e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c325e1",
  null
  
)

component.options.__file = "activity-read-only-questions.vue"
export default component.exports